// Object Assign
"function" != typeof Object.assign && (Object.assign = function (n) { if (null === n) throw new TypeError("Cannot convert undefined or null to object"); n = Object(n); for (var t = 1; t < arguments.length; t += 1) { var r = arguments[t]; if (null !== r) for (var e in r) Object.prototype.hasOwnProperty.call(r, e) && (n[e] = r[e]) } return n });
//# sourceMappingURL=/sm/1db3dcc0de8b3474a8a807782ece0b5ccd8699435df6e9adb2cd93f819c6530d.map

// TODO - Transpile all es6
// - convert all string templates
// - replace arrow functions, final, destructuring, and or, es6 utilities
// - update promises and test polyfill
// - check replace string polyfilled?
// - run scss w prefixes

function formatTheMoney(money, currency) {
    if (!currency) return new Intl.NumberFormat().format(money);
    return new Intl.NumberFormat((shop_locale || {}).iso_code || 'en', { style: 'currency', currency: currency }).format(money);
}

function gqlDecimalToFloat(gqlDecimal) {
    try {
        var val = parseFloat(gqlDecimal);
        return isNaN(val) ? 0 : val;
    } catch (e) {
        console.error(e);
        return 0;
    }
}

function moneyV2ToPrice(moneyV2) {
    if (!moneyV2) return null;
    var amount = moneyV2.amount || '0';
    var currencyCode = moneyV2.currencyCode;
    if (!currencyCode) return null;

    try {
        return formatTheMoney(gqlDecimalToFloat(amount), currencyCode);
    } catch (e) {
        console.error(e);
        return null;
    }
}

function connectionToNodeArray(connection) {
    try {
        if (connection && connection.edges && connection.edges.length > 0) {
            var nodes = [];
            for (var i = 0; i < connection.edges.length; i++) {
                var edge = connection.edges[i];
                if (edge && edge.node) nodes.push(edge.node);
            }
            return nodes;
        }
        return [];
    } catch (e) {
        console.error(e);
        return [];
    }
}

function parseGid(gid) {
    try {
        var id = gid;
        try {
           id = '/' + atob(gid);
        } catch (e) {}
        var gidRegexp = /\/(\w[\w-]*)(?:\?(.*))*$/;
        var matches = gidRegexp.exec(id);
        if (matches && matches[1] !== undefined) {
            return matches[1];
        }
        throw new Error(`Invalid gid: ${gid}`);
    } catch (e) {
        console.error(e);
        return null;
    }
}

window.addonState = window.addonState || {};

window.addonStateMap = {};
window.addonStateContext = "PAGE";
window.switchContext = function(new_context) {
    window.addonStateMap[window.addonStateContext] = window.addonState;
    window.addonStateContext = new_context;
    window.addonState = window.addonStateMap[new_context] || {};
    if (new_context != "PAGE") {
        window.addonState.productLineKey = new_context;
    }
}

// type should be _gift_wrap, _gift_card or _engraving -> properties added
function removeProductAddon(prodLineKey, type) {
    return axios.get('/cart.js').then(function (res) {
        var cart = res.data;
        var addonIndex;

        for (var i = 0; i < cart.items.length; i++) {
            var item = cart.items[i];
            item.properties = item.properties || {}
            if (item.properties['_product-line-key'] !== prodLineKey || item.properties[type] !== "true") {
                continue;
            }
            addonIndex = i + 1;
            break;
        }

        // check if index is defined or greater than 0 
        if (!addonIndex) return;

        return axios.post('/cart/change.js', {
            line: addonIndex,
            quantity: 0
        });
    })
}

function initializeProductAddons() {
    var DOMAIN_ATTR = 'data-domain';
    var STOREFRONT_API_URL = `//${$('body').attr(DOMAIN_ATTR)}/api/graphql.json`;
    var STOREFRONT_API_BEARER = '32bba9f2775d7ffec81f6cb6601767e5';

    var wordPrice = $('[data-engraving-price]').attr('data-engraving-price');
    wordPrice = !isNaN(parseInt(wordPrice)) ? parseInt(wordPrice) : 0;
    wordPrice = wordPrice / 100; // cents

    var GQLQ_PRODUCT_BY_COLLECTION = `
    query CollectionQueryProductAddons($collectionHandle: String!, $productCount: Int!) {
      collection: collectionByHandle(handle: $collectionHandle) {
        products(first: $productCount, sortKey: MANUAL) {
          edges {
            node {
              id
              title
              images(first: 1) {
                edges {
                  node {
                    transformedSrc(maxWidth: 1000)
                  }
                }
              }
              variants(first: 1) {
                edges {
                  node {
                    id
                    compareAtPriceV2 {
                      amount
                      currencyCode
                    }
                    priceV2 {
                      amount
                      currencyCode
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `;

    // var GQLQ_VARIANT_BY_ID = `
    //   query ProductQuery($id: String!) {
    //     productVariant(id:$id) {
    //       id
    //       product{
    //         images(first:1) {
    //           edges{
    //             node {
    //               transformedSrc(maxWidth: 500)
    //             }
    //           }
    //         }
    //       }
    //     }
    //   }
    // `;

    // storefront workaround variants
    function GQLQ_VARIANT_BY_ID(id) {
        return `
    query {
      node(id: "${id}") {
        ...on ProductVariant {
          id
          product {
            images(first:1) {
              edges {
                node {
                  transformedSrc(maxWidth: 500)
                }
              }
            }
          }
        }
      }
    }
  `;
    }

    var PRODUCT_TEMPLATE_SELECTOR = '[data-product-wrapper]';
    var PRODUCT_ADDONS_GROUP_SELECTOR = '[data-product-addons]';
    var PRODUCT_ADDON_SELECTOR = '[data-product-addon]';
    var GIFT_CARD_ADDON_CONTAINER_SELECTOR = '[data-gift-card-addon]';
    var GIFT_WRAP_ADDON_CONTAINER_SELECTOR = '[data-gift-wrap-addon]';
    var ENGRAVING_ADDON_CONTAINER_SELECTOR = '[data-engraving-addon]';
    var VIDEO_ADDON_CONTAINER_SELECTOR = '[data-video-addon]';
    var COLLECTION_FILTER_ATTR = 'data-filter-collection';

    var PRODUCT_ADDON_POPUP_SELECTOR = '[data-product-addon-popup]';
    var PRODUCT_ADDON_POPUP_CLOSE_SELECTOR = '[data-product-popup-addon-close]';
    var CLASS_POPUP_OPEN = 'is-popup-open';
    var CLASS_CURRENT_STEP = 'is-current-step';
    var CLASS_POPUP_LAST_PAGE = 'is-last-page';
    var CLASS_SELECTED = 'is-selected';

    var PRODUCT_ADDONS_POPUP_TRIGGER_ATTR = 'data-open-popup-trigger';

    var PRODUCT_ADDONS_POPUP_STATE_KEY_ATTR = 'data-product-addon-state-key';
    var PRODUCT_ADDONS_POPUP_STEP_PROVIDER_SELECTOR = '[data-product-addon-step-provider]';
    var PRODUCT_ADDONS_POPUP_STEP_PROVIDER_ATTR = 'data-product-addon-step-provider';
    var PRODUCT_ADDONS_POPUP_STEP_LISTENER_SELECTOR = '[data-product-addon-step-listener]';
    var PRODUCT_ADDONS_POPUP_STEP_LISTENER_ATTR = 'data-product-addon-step-listener';
    var PRODUCT_ADDONS_POPUP_STEP_STATE_SELECTOR = '[data-product-addon-step-state]';
    var PRODUCT_ADDONS_POPUP_GIFT_CARD_SELECTOR = '[data-product-addon-popup-gift-card]';
    var PRODUCT_ADDONS_POPUP_GIFT_WRAP_SELECTOR = '[data-product-addon-popup-gift-wrap]';

    var PRODUCT_ADDONS_POPUP_STEP_NEXT_SELECTOR = '[data-product-addon-step-next]';
    var PRODUCT_ADDONS_POPUP_COMPLETE_SELECTOR = '[data-product-addon-step-complete]';


    var logo = 'https://cdn.shopify.com/s/files/1/0043/9258/3217/files/ksclogo2_256x256.png?v=1565236310';
    var closeSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-x"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>';

    var PRODUCT_ADDON_POPUP_GIFT_CARD_KEY = 'giftCard';
    var PRODUCT_ADDON_POPUP_GIFT_WRAP_KEY = 'giftWrap';
    var PRODUCT_ADDON_POPUP_ENGRAVING_KEY = 'engraving';
    var PRODUCT_ADDON_POPUP_VIDEO_KEY = 'video';

    var popupTemplates = {
        [PRODUCT_ADDON_POPUP_GIFT_CARD_KEY]: {
            steps: [
                {
                    step: translations['product.addons.gift_card_first_step'],
                    buildContent: function (products) {
                        var state = addonState.giftCard || {};
                        return buildAddonPopupItems(products, 'data-product-addon-popup-gift-card', state.giftCardId);
                    },
                },
                {
                    step: translations['product.addons.gift_card_second_step'],
                    buildContent: function () {
                        var state = addonState.giftCard || {};
                        return `
              <div class="c-product-addon__message-inputs">
                <div class="c-product-addon__message-input is-input-to">
                  <span>${translations['product.addons.gift_card_message_heading_to']}</span>
                  <input data-product-addon-gift-card-to placeholder="${translations['product.addons.gift_card_message_placeholder_to']}" value="${state.to || ''}" />
                </div>
                <div class="c-product-addon__message-input is-input-from">
                  <span>${translations['product.addons.gift_card_message_heading_from']}</span>
                  <input data-product-addon-gift-card-from placeholder="${translations['product.addons.gift_card_message_placeholder_from']}" value="${state.from || ''}" />
                </div>
                <div class="c-product-addon__message-input is-input-message">
                  <span>${translations['product.addons.gift_card_message_heading_message']}</span>
                  <textarea data-product-addon-gift-card-message placeholder="${translations['product.addons.gift_card_message_placeholder_message']}">${state.message || ''}</textarea>
                </div>
              </div>
            `;
                    }
                }
            ],
            // return true to go to the next page, false to cancel
            // gift card select
            onContinue: function (popupContainer) {
                var $popupContainer = $(popupContainer);
                var productTile = $popupContainer.find(`${PRODUCT_ADDONS_POPUP_GIFT_CARD_SELECTOR}.${CLASS_SELECTED}`);

                if (!productTile.length) {
                    console.log('gift card not selected');
                    return false;
                }

                var productId = productTile.attr('data-product-id');
                var variantId = productTile.attr('data-variant-id');
                setPopupContentState($popupContainer, PRODUCT_ADDON_POPUP_GIFT_CARD_KEY, {
                    giftCardId: variantId,
                    productId: productId
                });

                var $selectedGiftCard = $(`${PRODUCT_ADDONS_POPUP_GIFT_CARD_SELECTOR}.${CLASS_SELECTED}`);
                var image = $selectedGiftCard.find('img').attr('src');
                $popupContainer.find('.c-product-addon__popup-banner').find('img').attr('src', image);

                return true;
            },
            // return true to go to the next page, false to cancel
            // adding message (message is required)
            onComplete: function (popupContainer) {
                var popupContainer = $(popupContainer);
                var PRODUCT_ADDONS_GIFT_CARD_TO_SELECTOR = '[data-product-addon-gift-card-to]';
                var PRODUCT_ADDONS_GIFT_CARD_FROM_SELECTOR = '[data-product-addon-gift-card-from]';
                var PRODUCT_ADDONS_GIFT_CARD_MESSAGE_SELECTOR = '[data-product-addon-gift-card-message]';

                var to = popupContainer.find(PRODUCT_ADDONS_GIFT_CARD_TO_SELECTOR).val();
                var from = popupContainer.find(PRODUCT_ADDONS_GIFT_CARD_FROM_SELECTOR).val();
                var message = popupContainer.find(PRODUCT_ADDONS_GIFT_CARD_MESSAGE_SELECTOR).val();

                if (!message) {
                    console.log('message not selected');
                    return false;
                }

                setPopupContentState(popupContainer, PRODUCT_ADDON_POPUP_GIFT_CARD_KEY, {
                    to: to,
                    from: from,
                    message: message
                });

                var $giftCardPopupTrigger = $(`[data-addon-context="${window.addonStateContext}"] ${GIFT_CARD_ADDON_CONTAINER_SELECTOR}`);
                var $selectedGiftCard = $(`${PRODUCT_ADDONS_POPUP_GIFT_CARD_SELECTOR}.${CLASS_SELECTED}`);
                var image = $selectedGiftCard.find('img').attr('src');
                $giftCardPopupTrigger.find('img').attr('src', image);
                var title = $selectedGiftCard.find('.c-product-addon__content__title').html();
                var price = $selectedGiftCard.find('[data-product-addon-price]').html();// inside the popup
                $giftCardPopupTrigger.find('.c-product-addon__content__title').html(title);
                $giftCardPopupTrigger.find('[data-product-addon-price]').html(price);// inside the popup
                $giftCardPopupTrigger.addClass(CLASS_SELECTED);

                if (addonState.productLineKey) { // means the flyout is open and this is the post add to cart upsell
                    window.startCartLoading();
                    axios.get('/cart.js').then(function (res) {
                        var data = res.data;
                        var giftCardProps = {};

                        var currentLineItem = $.grep(data.items, function (li) {
                            return li.key === addonState.productLineKey;
                        })
                        if (currentLineItem && Array.isArray(currentLineItem)) currentLineItem = currentLineItem[0]

                        for (var i = 0; i < data.items.length; i++) {
                            var item = data.items[i];
                            item.properties = item.properties || {};

                            // get extra props
                            if (item.properties['_product-line-key'] !== addonState.productLineKey || item.properties['_gift_card'] !== "true") {
                                continue;
                            }
                            giftCardProps = item.properties;
                            break;
                        }

                        if (!addonState.giftCard || !addonState.giftCard.giftCardId) return;

                        // add props again
                        giftCardProps['_product-line-key'] = addonState.productLineKey;
                        giftCardProps['_gift_card'] = "true";
                        giftCardProps['To'] = addonState.giftCard.to;
                        giftCardProps['From'] = addonState.giftCard.from;
                        giftCardProps['Message'] = addonState.giftCard.message;

                        if (currentLineItem) {
                            giftCardProps['Product Handle'] = currentLineItem.variant_title || currentLineItem.product_title;
                            giftCardProps['Sku'] = currentLineItem.sku;
                        } else {
                            console.log('wtf')
                        }

                        // remove addon crap then add it again
                        removeProductAddon(addonState.productLineKey, '_gift_card').then(function () {
                            axios.post('/cart/add.js', {
                                quantity: 1, id: addonState.giftCard.giftCardId, properties: giftCardProps
                            })
                            .then(resp => {
                                window.addonState = {};
                                window.openCartDrawer()
                            });
                        });
                    })
                } else {
                    if (document.querySelector("[data-product-atc-text]"))
                        document.querySelector("[data-product-atc-text]").innerText = "ADD PRODUCT + GIFTING TO CART";
                }

                return true;
            }
        },
        [PRODUCT_ADDON_POPUP_GIFT_WRAP_KEY]: {
            steps: [
                {
                    step: translations['product.addons.gift_wrap_first_step'],
                    buildContent: function (products) {
                        var state = addonState.giftWrap || {};
                        return buildAddonPopupItems(products, 'data-product-addon-popup-gift-wrap', state.giftWrapId);
                    }
                }
            ],
            // return true to go to the next page, false to cancel
            // no continue button
            onContinue: function (popupContainer) { return true; },
            // return true to go to the next page, false to cancel
            onComplete: function (popupContainer) {
                var productTile = popupContainer.find(`${PRODUCT_ADDONS_POPUP_GIFT_WRAP_SELECTOR}.${CLASS_SELECTED}`);
                if (!productTile.length) {
                    console.log('gift wrap not selected');
                    return false;
                }

                var productId = productTile.attr('data-product-id');
                var variantId = productTile.attr('data-variant-id');
                setPopupContentState(popupContainer, PRODUCT_ADDON_POPUP_GIFT_WRAP_KEY, {
                    giftWrapId: variantId,
                    productId: productId
                });

                var $giftWrapPopupTrigger = $(`[data-addon-context="${window.addonStateContext}"] ${GIFT_WRAP_ADDON_CONTAINER_SELECTOR}`);
                var $selectedGiftCard = $(`${PRODUCT_ADDONS_POPUP_GIFT_WRAP_SELECTOR}.${CLASS_SELECTED}`);
                var image = $selectedGiftCard.find('img').attr('src');
                $giftWrapPopupTrigger.find('img').attr('src', image);
                var title = $selectedGiftCard.find('.c-product-addon__content__title').html();
                var price = $selectedGiftCard.find('[data-product-addon-price]').html();
                $giftWrapPopupTrigger.find('.c-product-addon__content__title').html(title);
                $giftWrapPopupTrigger.find('[data-product-addon-price]').html(price);
                $giftWrapPopupTrigger.addClass(CLASS_SELECTED);
                console.log("TRIGGER", $giftWrapPopupTrigger);

                if (addonState.productLineKey) { // means the flyout is open and this is the post add to cart upsell
                    window.startCartLoading();
                    axios.get('/cart.js').then(function (res) {
                        var data = res.data;
                        var giftWrapProps = {};


                        var currentLineItem = $.grep(data.items, function (li) {
                            return li.key === addonState.productLineKey;
                        });
                        if (currentLineItem && Array.isArray(currentLineItem)) currentLineItem = currentLineItem[0]

                        for (var i = 0; i < data.items.length; i++) {
                            var item = data.items[i];
                            item.properties = item.properties || {}
                            // console.log(item.properties['_product-line-key'], addonState.productLineKey, item.properties['_gift_wrap'], "true", 'fuck')
                            if (item.properties['_product-line-key'] !== addonState.productLineKey || item.properties['_gift_wrap'] !== "true") {
                                continue;
                            }
                            giftWrapProps = item.properties;
                            break;
                        }

                        // TODO: Fetch variant name and sku with line key and add to props
                        giftWrapProps['_product-line-key'] = addonState.productLineKey;
                        giftWrapProps['_gift_wrap'] = "true";

                        if (currentLineItem) {
                            giftWrapProps['Product Handle'] = currentLineItem.variant_title || currentLineItem.product_title;
                            giftWrapProps['Sku'] = currentLineItem.sku;
                        } else {
                            console.log('wtf')
                        }

                        if (!addonState.giftWrap || !addonState.giftWrap.giftWrapId) return;

                        removeProductAddon(addonState.productLineKey, '_gift_wrap').then(function () {
                            axios.post('/cart/add.js', {
                                quantity: 1, id: addonState.giftWrap.giftWrapId, properties: giftWrapProps
                            })
                            .then(resp => {
                                window.addonState = {};
                                window.openCartDrawer()
                            });
                        });
                    })
                } else {
                    if (document.querySelector("[data-product-atc-text]"))
                        document.querySelector("[data-product-atc-text]").innerText = "ADD PRODUCT + GIFTING TO CART";
                }

                return true;
            }
        },
        [PRODUCT_ADDON_POPUP_ENGRAVING_KEY]: {
            steps: [
                {
                    step: '$' + wordPrice + ' ' + translations['product.addons.engraving_first_step'],
                    buildContent: function () {
                        var state = addonState.engraving || {};
                        return `
              <div class="c-product-addon__message-inputs">
                <div class="c-product-addon__message-input">
                  <span>${translations['product.addons.engraving_heading_line_1']}</span>
                  <input data-product-addon-engraving-line-1 placeholder="${translations['product.addons.engraving_placeholder_line_1']}" value="${state.line1 || ''}" />
                </div>
                <div class="c-product-addon__message-input">
                  <span>${translations['product.addons.engraving_heading_line_2']}</span>
                  <input data-product-addon-engraving-line-2 placeholder="${translations['product.addons.engraving_placeholder_line_2']}" value="${state.line2 || ''}" />
                </div>
                <div class="c-product-addon__message-input">
                  <span>${translations['product.addons.engraving_heading_line_3']}</span>
                  <input data-product-addon-engraving-line-3 placeholder="${translations['product.addons.engraving_placeholder_line_3']}" value="${state.line3 || ''}" />
                </div>
                <span class="c-product-addon__engraving-notif">${translations['product.addons.engraving_popup_message']}</span>
              </div>
            `;
                    }
                }
            ],
            // return true to go to the next page, false to cancel
            onContinue: function (popupContainer) { return true; },
            // return true to go to the next page, false to cancel
            onComplete: function (popupContainer) {
                var popupContainer = $(popupContainer);
                var PRODUCT_ADDONS_ENGRAVING_INPUT_1_SELECTOR = '[data-product-addon-engraving-line-1]';
                var PRODUCT_ADDONS_ENGRAVING_INPUT_2_SELECTOR = '[data-product-addon-engraving-line-2]';
                var PRODUCT_ADDONS_ENGRAVING_INPUT_3_SELECTOR = '[data-product-addon-engraving-line-3]';
                var PRODUCT_ADDONS_ENGRAVING_ID_ATTR = 'data-engraving-product';

                var engravingId = $(`[${PRODUCT_ADDONS_ENGRAVING_ID_ATTR}]`).attr(PRODUCT_ADDONS_ENGRAVING_ID_ATTR);

                var line1 = popupContainer.find(PRODUCT_ADDONS_ENGRAVING_INPUT_1_SELECTOR).val() || '';
                var line2 = popupContainer.find(PRODUCT_ADDONS_ENGRAVING_INPUT_2_SELECTOR).val() || '';
                var line3 = popupContainer.find(PRODUCT_ADDONS_ENGRAVING_INPUT_3_SELECTOR).val() || '';

                // var wordCount = (line1 + ' ' + line2 + ' ' + line3).trim().split(/\s+/gim).length;

                setPopupContentState(popupContainer, PRODUCT_ADDON_POPUP_ENGRAVING_KEY, {
                    line1: line1,
                    line2: line2,
                    line3: line3,
                    quantity: 1,
                    engravingId: engravingId
                });

                var $engravingPopupTrigger = $(`[data-addon-context="${window.addonStateContext}"] ${ENGRAVING_ADDON_CONTAINER_SELECTOR}`);
                $engravingPopupTrigger.addClass(CLASS_SELECTED);


                if (addonState.productLineKey) { // means the flyout is open and this is the post add to cart upsell
                    window.startCartLoading();
                    axios.get('/cart.js').then(function (res) {
                        var data = res.data;
                        var engravingProps = {};

                        var currentLineItem = $.grep(data.items, function (li) {
                            return li.key === addonState.productLineKey;
                        })
                        if (currentLineItem && Array.isArray(currentLineItem)) currentLineItem = currentLineItem[0]

                        for (var i = 0; i < data.items.length; i++) {
                            var item = data.items[i];
                            item.properties = item.properties || {}
                            // console.log(item.properties['_product-line-key'], addonState.productLineKey, item.properties['_gift_wrap'], "true", 'fuck')
                            if (item.properties['_product-line-key'] !== addonState.productLineKey || item.properties['_engraving'] !== "true") {
                                continue;
                            }
                            engravingProps = item.properties;
                            break;
                        }

                        // TODO: Fetch variant name and sku with line key and add to props
                        engravingProps['_product-line-key'] = addonState.productLineKey;
                        engravingProps['_engraving'] = "true";

                        if (currentLineItem) {
                            engravingProps['Product Handle'] = currentLineItem.variant_title || currentLineItem.product_title;
                            engravingProps['Sku'] = currentLineItem.sku;
                        } else {
                            console.log('wtf')
                        }

                        if (!addonState.engraving || !addonState.engraving.engravingId) return;

                        engravingProps['Line 1'] = addonState.engraving.line1;
                        engravingProps['Line 2'] = addonState.engraving.line2;
                        engravingProps['Line 3'] = addonState.engraving.line3;

                        console.log(engravingProps)
                        removeProductAddon(addonState.productLineKey, '_engraving').then(function () {
                            axios.post('/cart/add.js', {
                                // quantity: parseInt(addonState.engraving.quantity), id: addonState.engraving.engravingId, properties: engravingProps

                                quantity: 1, id: addonState.engraving.engravingId, properties: engravingProps
                            })
                            .then(resp => {
                                window.addonState = {};
                                window.openCartDrawer()
                            });
                        });
                    })
                } else {
                    if (document.querySelector("[data-product-atc-text]"))
                        document.querySelector("[data-product-atc-text]").innerText = "ADD PRODUCT + GIFTING TO CART";
                }

                return true;
            }
        },
        [PRODUCT_ADDON_POPUP_VIDEO_KEY]: {
            steps: [
                {
                    step: translations['product.addons.video_first_step'] || "",
                    buildContent: function () {
                        var state = addonState.video || {};
                        return `<div style="margin: 2em;">Personalise your gift with a video message recorded by you. Once you place your order with VideoGreet added to your cart, an email will be sent with instructions on how to record and send your customized video. Your gift recipient will receive a card with an unique QR code to scan on their mobile device and will be taken directly to your video. </div>`;
                    }
                }
            ],
            // return true to go to the next page, false to cancel
            onContinue: function (popupContainer) { return true; },
            // return true to go to the next page, false to cancel
            onComplete: function (popupContainer) {
                var popupContainer = $(popupContainer);

                var PRODUCT_ADDONS_VIDEO_ID_ATTR = 'data-video-product';

                var videoId = $(`[${PRODUCT_ADDONS_VIDEO_ID_ATTR}]`).attr(PRODUCT_ADDONS_VIDEO_ID_ATTR);

                setPopupContentState(popupContainer, PRODUCT_ADDON_POPUP_VIDEO_KEY, {
                    quantity: 1,
                    videoId: videoId
                });

                var $engravingPopupTrigger =  $(`[data-addon-context="${window.addonStateContext}"] ${VIDEO_ADDON_CONTAINER_SELECTOR}`);
                $engravingPopupTrigger.addClass(CLASS_SELECTED);


                if (addonState.productLineKey) { // means the flyout is open and this is the post add to cart upsell
                    window.startCartLoading();
                    axios.get('/cart.js').then(function (res) {
                        var data = res.data;
                        var engravingProps = {};

                        var currentLineItem = $.grep(data.items, function (li) {
                            return li.key === addonState.productLineKey;
                        })
                        if (currentLineItem && Array.isArray(currentLineItem)) currentLineItem = currentLineItem[0]

                        for (var i = 0; i < data.items.length; i++) {
                            var item = data.items[i];
                            item.properties = item.properties || {}
                            // console.log(item.properties['_product-line-key'], addonState.productLineKey, item.properties['_gift_wrap'], "true", 'fuck')
                            if (item.properties['_product-line-key'] !== addonState.productLineKey || item.properties['_video'] !== "true") {
                                continue;
                            }
                            engravingProps = item.properties;
                            break;
                        }

                        // TODO: Fetch variant name and sku with line key and add to props
                        engravingProps['_product-line-key'] = addonState.productLineKey;
                        engravingProps['_video'] = "true";

                        if (currentLineItem) {
                            engravingProps['Product Handle'] = currentLineItem.variant_title || currentLineItem.product_title;
                            engravingProps['Sku'] = currentLineItem.sku;
                        } else {
                            console.log('wtf')
                        }

                        if (!addonState.video || !addonState.video.videoId) return;

                        console.log(engravingProps)
                        removeProductAddon(addonState.productLineKey, '_video').then(function () {
                            axios.post('/cart/add.js', {
                                // quantity: parseInt(addonState.engraving.quantity), id: addonState.engraving.engravingId, properties: engravingProps

                                quantity: 1, id: addonState.video.videoId, properties: engravingProps
                            })
                            .then(resp => {
                                window.addonState = {};
                                window.openCartDrawer()
                            });
                        });
                    })
                } else {
                    if (document.querySelector("[data-product-atc-text]"))
                        document.querySelector("[data-product-atc-text]").innerText = "ADD PRODUCT + GIFTING TO CART";
                }

                return true;
            }
        }
    }

    function fetchVariantById(variantId) {
        console.log(GQLQ_VARIANT_BY_ID(btoa(`gid://shopify/ProductVariant/${variantId}`)));
        return axios.post(STOREFRONT_API_URL, {
            query: GQLQ_VARIANT_BY_ID(btoa(`gid://shopify/ProductVariant/${variantId}`))
        }, {
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': `${STOREFRONT_API_BEARER}`
            }
        })
    }

    function fetchProductsByCollection(collectionHandle, productCount = 1) {
        return axios.post(STOREFRONT_API_URL, {
            query: GQLQ_PRODUCT_BY_COLLECTION,
            variables: {
                collectionHandle: collectionHandle,
                productCount: productCount
            }
        }, {
            headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': `${STOREFRONT_API_BEARER}`
            }
        })
    }

    function getPopupContentState(container) {
        if (!container) return;
        var $provider = $(container).find(PRODUCT_ADDONS_POPUP_STEP_PROVIDER_SELECTOR);
        var state = $provider.find(PRODUCT_ADDONS_POPUP_STEP_STATE_SELECTOR).html();

        try {
            // parse internal state, gets destroyed on popup close
            // data should be stored in memory before closing popup
            return JSON.parse(state) || {};
        } catch (e) {
            console.error('Content state not found');
            console.error(e);
            return null;
        }
    }

    function setPopupContentState(container, namespace, value) {
        if (!container) return;
        var $provider = $(container).find(PRODUCT_ADDONS_POPUP_STEP_PROVIDER_SELECTOR);
        var state = $provider.find(PRODUCT_ADDONS_POPUP_STEP_STATE_SELECTOR).html();

        try {
            var state = JSON.parse(state) || {};
            state[namespace] = Object.assign(state[namespace] || {}, value);
            $provider.find(PRODUCT_ADDONS_POPUP_STEP_STATE_SELECTOR).html(JSON.stringify(state));
        } catch (e) {
            console.error('Cannot set state');
            console.error(e);
            return null;
        }
    }

    function popupContentSetPage(container, step = 0) {
        if (!container) return;
        var state = getPopupContentState(container);
        var $provider = $(container).find(PRODUCT_ADDONS_POPUP_STEP_PROVIDER_SELECTOR);
        var steps = [];

        if (state === null) {
            $(PRODUCT_ADDON_POPUP_SELECTOR).removeClass(CLASS_POPUP_OPEN);
            $(document.body).removeClass(CLASS_POPUP_OPEN);
            return;
        }

        if (state.steps) steps = state.steps;
        if (!steps || !Array.isArray(steps)) return;

        var currentStep = parseInt($provider.attr(PRODUCT_ADDONS_POPUP_STEP_PROVIDER_ATTR) || "0");
        if (!isNaN(currentStep)) currentStep = 0;

        if (!isNaN(parseInt(step))) currentStep = parseInt(step);
        else if (step === 'next') currentStep += 1;
        else if (step === 'prev') currentStep -= 1;

        // Includes checks for the add button
        if (currentStep == steps.length - 1) $provider.addClass(CLASS_POPUP_LAST_PAGE);
        if (currentStep < 0 || currentStep >= steps.length) return;

        var $stepListeners = $provider.find(PRODUCT_ADDONS_POPUP_STEP_LISTENER_SELECTOR);

        // Set current step for provider and listeners
        $provider.attr(PRODUCT_ADDONS_POPUP_STEP_PROVIDER_ATTR, currentStep);

        // Set visibility
        $stepListeners.removeClass(CLASS_CURRENT_STEP);
        var $current = $provider.find(`[${PRODUCT_ADDONS_POPUP_STEP_LISTENER_ATTR}=${currentStep}]`);
        $current.addClass(CLASS_CURRENT_STEP);
    }

    function buildAddonPopupContent(key, banner, stepsConfig = [], heading = '') {
        var steps = $.map(stepsConfig, function (sc) { return sc.step });

        return `
      <div class="c-product-addon__popup-wrapper ${steps.length < 2 ? CLASS_POPUP_LAST_PAGE : ''}"
        data-product-addon-state-key=${key}
        data-product-addon-step-provider=0
      >
        <script data-product-addon-step-state type="application/json">
          ${JSON.stringify({ steps })}
        </script>
        <div class="c-product-addon__popup-header">
          <img class="c-product-addon__popup-header__logo" src="${logo}"/>
          <div class="c-product-addon__popup-close" data-product-popup-addon-close>${closeSVG}</div>
        </div>
        ${banner}
        <div class="c-product-addon__popup-content">
          <div class="c-product-addon__popup-content__header">
            <span class="c-product-addon__popup-content__header-title">
              ${heading || ''}
            </span>
            ${$.map(steps, function (step, idx) {
            return `
                <span data-product-addon-step-listener=${idx}>${step || ''}</span>
              `
        }).join('')}
          </div>
          ${$.map(stepsConfig, function (sc, idx) {
            return `
              <div data-product-addon-step-listener=${idx} class="c-product-addon__popup-content__body">
                ${typeof sc.buildContent === 'function' ? sc.buildContent() : ''}  
              </div>
            `;
        }).join('')}

          <div class="c-product-addon__popup-footer">
            ${steps && steps.length > 1 ? $.map(steps, function (step, idx) {
            if (idx === steps.length - 1) return '';
            return `
                <button
                  class="c-product-addon__popup-button"
                  data-product-addon-step-listener=${idx}
                  data-product-addon-step-next
                >
                  ${translations['product.addons.next_step'] || ''}
                </button>
              `;
        }).join('') : ''}
            <button 
              class="c-product-addon__popup-button is-add-button"
              data-product-addon-step-complete
            >
              ${key === PRODUCT_ADDON_POPUP_ENGRAVING_KEY ? '<div class="c-product-addon__popup__engraving-price" data-engraving-price-text></div>' : ''}
              ${translations['product.addons.add_to_cart'] || ''}
            </button>
          </div>

        </div>
      </div>
    `;
    }

    function buildAddonPopupItems(products, attrs = '', selected = '') {
        return `
      <div class="c-product-addon__popup-items">
        ${$.map(products, function (product) {
            var productImage = (connectionToNodeArray(product.images)[0] || {}).transformedSrc;
            var defaultVariant = (connectionToNodeArray(product.variants) || [])[0];
            var price = moneyV2ToPrice(defaultVariant.priceV2);

            var productId = parseGid(product.id);
            var defaultVariantId = parseGid(defaultVariant.id);
            if (!defaultVariantId) return '';

            return `
            <div class="c-product-addon ${selected && selected === defaultVariantId ? CLASS_SELECTED : ''}" data-product-id=${productId} data-variant-id=${defaultVariantId} ${attrs}>
              ${buildAddonProductTile(product.title, productImage, price)}
            </div>
          `;
        }).join('')}
      </div>
    `;
    }

    /**
     * const stepsConfig = [
     *   {
     *     step: '1. Step 1',
     * 
     *     buildContent: (products) => products.map(product => `<div>${product.title}</div>)`),
     *     
     *     -- return true to go to the next page, false to cancel
     *     onContinue: function(container) { return ``; },
     * 
     *     -- return true to go to the next page, false to cancel
     *     onSubmit: function(container) { return ``; }
     *   }
     * ]
     */
    function buildAddonPopup(key, productsConnection, stepsConfig = [], bannerImage = '', heading = '') {
        var products = connectionToNodeArray(productsConnection);
        var productImage = (connectionToNodeArray(products[0].images)[0] || {}).transformedSrc;

        var bannerHtml = `
      <div class="c-product-addon__popup-banner">
        <img src="${bannerImage || productImage}" />
      </div>
    `;

        $.each(stepsConfig, function (idx, sc) {
            var build = sc.buildContent;
            sc.buildContent = function () {
                return build(products);
            }
        });

        return buildAddonPopupContent(key, bannerHtml, stepsConfig, heading);
    }

    function buildEngravingPopup(key, bannerImage, stepsConfig = [], heading = '') {
        // console.log(bannerImage)
        var bannerHtml = `
      <div class="c-product-addon__popup-banner">
        <img src="${bannerImage}" />
      </div>
    `;

        return buildAddonPopupContent(key, bannerHtml, stepsConfig, heading);
    }

    function buildVideoPopup(key, bannerImage, stepsConfig = [], heading = '') {
        // console.log(bannerImage)
        var bannerHtml = `
      <div class="c-product-addon__popup-banner">
        <img src="${bannerImage}" />
      </div>
    `;

        return buildAddonPopupContent(key, bannerHtml, stepsConfig, heading);
    }

    function buildAddonProductTile(title, productImage, price, viewMessageDefault = '', messageDefault = '', imageDefault = '') {
        // add is active class when there's a default image only because we want it to show something
        return `
      <div class="c-product-addon__image-container">
        <img class="c-product-addon__image ${imageDefault ? 'is-active' : ''}" src="${productImage || ''}"/>
        ${imageDefault ? `<img class="c-product-addon__image is-default" src="${imageDefault || ''}"/>` : ''}
      </div>
      <div class="c-product-addon__content">
        <div class="c-product-addon__content__title">
          ${title}
          <span>${translations['product.addons.addon_edit']}</span>
        </div>
        <div class="c-product-addon__content__price is-active" data-product-addon-price>
          <span class="c-product-addon__content__from">${translations['product.addons.from_price'] || ''}</span> ${price}
        </div>
        ${messageDefault ? `
          <div class="c-product-addon__content__price is-default">
            <span class="c-product-addon__content__from">${messageDefault}</span>
          </div>
        ` : ''}
        ${viewMessageDefault ? `<span class="c-product-addon__content-view">${viewMessageDefault}</span>` : ''}
      </div>
    `;
    }

    // type = 'cart' | 'quickshop' | null
    function buildProductAddons(type) {
        var $addonGroup = $(`.product-details ${PRODUCT_ADDONS_GROUP_SELECTOR}`);
        
        if (type == "cart") {
            $addonGroup = $(`#cart-drawer ${PRODUCT_ADDONS_GROUP_SELECTOR}`);
        }

        /*var $giftCardAddon = $addonGroup.find(GIFT_CARD_ADDON_CONTAINER_SELECTOR);
        var $giftWrapAddon = $addonGroup.find(GIFT_WRAP_ADDON_CONTAINER_SELECTOR);

        var giftCardFilter = $giftCardAddon.attr(COLLECTION_FILTER_ATTR);
        var giftWrapFilter = $giftWrapAddon.attr(COLLECTION_FILTER_ATTR);*/
        
        if (type === 'quickshop') {
            console.log('Building quickshop product addons ~ not pdp')
            // var productAddonsHtmlDefault = $($($('[data-product-addon-template]').html())[0]).find('[data-product-addons]').html();
            // $('[data-product-addons]').html(productAddonsHtmlDefault);
        }

        if (type == "cart") {
            // Addons appearing in cart, fill in their properties...
            $addonGroup.each(function (index) {
                const el = this;
                const context = el.dataset.addonContext;
                const parent = document.querySelectorAll(`#cart-drawer [data-parent-key="${context}"]`);
                switchContext(context);
                // TODO this in a better WAY
                el.parentElement.parentElement.parentElement.parentElement.style.order = `${index*100}`;

                document.querySelectorAll(`#cart-drawer [data-addon-key="${context}"]`).forEach(cart_el => {
                    eval(cart_el.querySelector("[data-addon-properties]").innerText);
                    const addonItem =  window.addonItem;
                    // TODO put item props in HTML so we can access them here.
                    cart_el.style.order = `${index*100 + 1}`;
                    console.log(cart_el);
                    if (cart_el.dataset.engraving == "true") {
                        el.querySelector(ENGRAVING_ADDON_CONTAINER_SELECTOR).classList.add(CLASS_SELECTED);
                        addonState.engraving = {
                            engravingId: `${addonItem.id}`,
                            line1: addonItem.properties["Line 1"],
                            line2: addonItem.properties["Line 2"],
                            line3: addonItem.properties["Line 3"],
                        };
                    } else if (cart_el.dataset.wrapping == "true") {
                        el.querySelector(GIFT_WRAP_ADDON_CONTAINER_SELECTOR).classList.add(CLASS_SELECTED);
                        addonState.giftWrap = {
                            giftWrapId: `${addonItem.id}`
                        }

                        el.querySelector(GIFT_WRAP_ADDON_CONTAINER_SELECTOR).innerHTML = 
                            buildAddonProductTile("Gift Wrapping", addonItem.featured_image.url, formatTheMoney(addonItem.price/100, "AUD"));
                    } else if (cart_el.dataset.giftcard == "true") {
                        el.querySelector(GIFT_CARD_ADDON_CONTAINER_SELECTOR).classList.add(CLASS_SELECTED);
                        addonState.giftCard = {
                            giftCardId: `${addonItem.id}`,
                            to: addonItem.properties["To"],
                            from: addonItem.properties["From"],
                            message: addonItem.properties["Message"],
                        };
                        el.querySelector(GIFT_CARD_ADDON_CONTAINER_SELECTOR).innerHTML = 
                            buildAddonProductTile("Gift Card", addonItem.featured_image.url, formatTheMoney(addonItem.price/100, "AUD"));
                    }
                });

            });
        }

        /*return $.map([giftCardFilter, giftWrapFilter], function (filter, idx) {
            if (filter) {
                return fetchProductsByCollection(filter, 1)
                    .then(function (res) {
                        if (res.data.errors) throw new Error(JSON.stringify(res.data.errors));
                        var productConnection = res.data.data.collection.products;

                        if (idx === 0) {
                            $giftCardAddon.html(buildGiftCardLayout(productConnection));
                        } else if (idx === 1) {
                            $giftWrapAddon.html(buildGiftWrapLayout(productConnection));
                        }
                    });
            }
        })*/
        // .then(function(res) {
        //     var productAddonsHtmlDefault = $($($('[data-product-addon-template]').html())[0]).find('[data-product-addons]').html();
        //     console.log(productAddonsHtmlDefault)
        //     $('[data-product-addons]').html(productAddonsHtmlDefault);
        // });
    }

    function initializePopup(popup, popupHtml) {
        var $popup = $(popup);
        $(PRODUCT_ADDON_POPUP_SELECTOR).removeClass(CLASS_POPUP_OPEN);
        $(document.body).addClass(CLASS_POPUP_OPEN);
        $popup.addClass(CLASS_POPUP_OPEN);
        $popup.html(popupHtml);
        popupContentSetPage($popup, 0);
    }

    function registerPopupRedrawEvent() {
        $(document).on('click', `${PRODUCT_ADDONS_GROUP_SELECTOR} ${PRODUCT_ADDON_SELECTOR}`, function (el) {
            var $trigger = $(el.currentTarget);

            var context = $trigger.parent().data("addonContext") || "PAGE";
            switchContext(context);

            var filter = $trigger.attr(COLLECTION_FILTER_ATTR);
            var popupSelector = $trigger.attr(PRODUCT_ADDONS_POPUP_TRIGGER_ATTR);
            var $popup = $(popupSelector);

            console.log(popupSelector, $popup, !$popup.length);

            if (!popupSelector || !$popup || !$popup.length) return;

            var stepsConfig = [];
            var stateKey = 'default';
            var selectedProductId = '';
            var heading = '';

            // Handle all popups here
            if (typeof
                $trigger.attr(GIFT_CARD_ADDON_CONTAINER_SELECTOR.replace(/[\[\]]/gim, '')
                ) !== typeof undefined) {
                stepsConfig = popupTemplates.giftCard.steps;
                stateKey = PRODUCT_ADDON_POPUP_GIFT_CARD_KEY;
                selectedProductId = ((addonState || {}).giftCard || {}).productId || '';
                heading = translations['product.addons.gift_card_heading_title'] || '';
            } else if (typeof
                $trigger.attr(GIFT_WRAP_ADDON_CONTAINER_SELECTOR.replace(/[\[\]]/gim, '')
                ) !== typeof undefined) {
                stepsConfig = popupTemplates.giftWrap.steps;
                stateKey = PRODUCT_ADDON_POPUP_GIFT_WRAP_KEY;
                selectedProductId = ((addonState || {}).giftWrap || {}).productId || '';
                heading = translations['product.addons.gift_wrap_heading_title'] || '';
            } else if (typeof
                $trigger.attr(ENGRAVING_ADDON_CONTAINER_SELECTOR.replace(/[\[\]]/gim, '')
                ) !== typeof undefined) {
                stepsConfig = popupTemplates.engraving.steps;
                if (templateName === 'product' && product_data) {
                    initializePopup($popup, buildEngravingPopup(
                        PRODUCT_ADDON_POPUP_ENGRAVING_KEY,
                        ((product_data || {}).image || [])[0] || '',
                        stepsConfig,
                        translations['product.addons.engraving_heading_title'] || ''
                    ));
                }
                // Post add to cart / flyout and not on the product page where product data is available
                else if (addonState.productLineKey) {
                    var wordPrice = $('[data-engraving-price]').attr('data-engraving-price');
                    wordPrice = !isNaN(parseInt(wordPrice)) ? parseInt(wordPrice) : 0;
                    wordPrice = wordPrice / 100; // cents
                    stepsConfig[0].step = '$' + wordPrice + ' ' + translations['product.addons.engraving_first_step'];
                    // doing this cause there's no damn async await
                    fetch('/cart.js').then(function (res) { return res.json() }).then(function (data) {
                        if (!Array.isArray(data.items)) return;
                        if (!data.items.length) return;

                        var product = $.grep(data.items, function (item) { return item.properties["_addon-line-key"] === addonState.productLineKey })[0];
                        initializePopup($popup, buildEngravingPopup(
                            PRODUCT_ADDON_POPUP_ENGRAVING_KEY,
                            (product || {}).image || '',
                            stepsConfig,
                            translations['product.addons.engraving_heading_title'] || ''
                        ));

                        $('[data-engraving-price-text]').html('$' + wordPrice + ' —');
                    })
                } else {
                    var wordPrice = $('[data-engraving-price]').attr('data-engraving-price');
                    wordPrice = !isNaN(parseInt(wordPrice)) ? parseInt(wordPrice) : 0;
                    wordPrice = wordPrice / 100; // cents
                    stepsConfig[0].step = '$' + wordPrice + ' ' + translations['product.addons.engraving_first_step'];

                    var $productFormProductId = $('.modal-visible .modal--quickshop-full [data-product-form-area] [data-product-form] input[name="id"]');
                    if (!$productFormProductId || !$productFormProductId.length || typeof $productFormProductId.val !== 'function') return;
                    var productFormProductId = $productFormProductId.val();
                    fetchVariantById(productFormProductId).then(function (data) {
                        var variantData = ((((data || {}).data || {}).data || {}).node || {});
                        var variantProductImages = connectionToNodeArray(variantData.product.images);
                        initializePopup($popup, buildEngravingPopup(
                            PRODUCT_ADDON_POPUP_ENGRAVING_KEY,
                            ((variantProductImages || [])[0] || {}).transformedSrc || '',
                            stepsConfig,
                            translations['product.addons.engraving_heading_title'] || ''
                        ));
                    });
                }
                return;
            } else if (typeof
                $trigger.attr(VIDEO_ADDON_CONTAINER_SELECTOR.replace(/[\[\]]/gim, '')
                ) !== typeof undefined) {
                stepsConfig = popupTemplates.video.steps;
                stateKey = PRODUCT_ADDON_POPUP_VIDEO_KEY;
                selectedProductId = ((addonState || {}).video || {}).productId || '';
                var video_image_element = document.querySelector("[data-video-image]");
                video_image_element = video_image_element.getAttribute("data-video-image");

                if (templateName === 'product' && product_data) {
                    initializePopup($popup, buildVideoPopup(
                        PRODUCT_ADDON_POPUP_VIDEO_KEY,
                        video_image_element || ((product_data || {}).image || [])[0] || '',
                        stepsConfig,
                        translations['product.addons.video_title'] || ''
                    ));
                }
                // Post add to cart / flyout and not on the product page where product data is available
                else if (addonState.productLineKey) {
                    fetch('/cart.js').then(function (res) { return res.json() }).then(function (data) {
                        if (!Array.isArray(data.items)) return;
                        if (!data.items.length) return;

                        var product = $.grep(data.items, function (item) { return item.key === addonState.productLineKey })[0];
                        initializePopup($popup, buildVideoPopup(
                            PRODUCT_ADDON_POPUP_VIDEO_KEY,
                            video_image_element || product.image || '',
                            stepsConfig,
                            translations['product.addons.video_title'] || ''
                        ));

                        $('[data-video-price-text]').html('$' + wordPrice + ' —');
                    })
                } else {
                    var $productFormProductId = $('.modal-visible .modal--quickshop-full [data-product-form-area] [data-product-form] input[name="id"]');
                    if (!$productFormProductId || !$productFormProductId.length || typeof $productFormProductId.val !== 'function') return;
                    var productFormProductId = $productFormProductId.val();
                    fetchVariantById(productFormProductId).then(function (data) {
                        var variantData = ((((data || {}).data || {}).data || {}).node || {});
                        var variantProductImages = connectionToNodeArray(variantData.product.images);
                        initializePopup($popup, buildVideoPopup(
                            PRODUCT_ADDON_POPUP_VIDEO_KEY,
                            video_image_element || ((variantProductImages || [])[0] || {}).transformedSrc || '',
                            stepsConfig,
                            translations['product.addons.video_title'] || ''
                        ));
                    });
                }
                return;
            } else {
                return;
            }

            fetchProductsByCollection(filter, 40)
                .then(function (res) {
                    if (res.data.errors) throw new Error(JSON.stringify(res.data.errors));
                    var productConnection = res.data.data.collection.products;

                    var products = connectionToNodeArray(productConnection);
                    var selectedProducts = $.grep(products, function (product) {
                        return parseGid(product.id) === selectedProductId;
                    });

                    var bannerImage = '';
                    if (selectedProducts && Array.isArray(selectedProducts) && selectedProducts[0] && selectedProducts[0].images) {
                        bannerImage = (connectionToNodeArray(selectedProducts[0].images)[0] || {}).transformedSrc;
                    }
                    initializePopup($popup, buildAddonPopup(stateKey, productConnection, stepsConfig, bannerImage, heading));
                })
                .catch(function (e) {
                    console.error(e)
                });
        });
    }

    function registerPopupPaginationEvent() {
        $(document).on('click', `${PRODUCT_ADDON_POPUP_SELECTOR} ${PRODUCT_ADDONS_POPUP_STEP_NEXT_SELECTOR}`, function (el) {
            var $nextButton = $(el.currentTarget);
            var $popup = $nextButton.closest(PRODUCT_ADDON_POPUP_SELECTOR);
            var $provider = $popup.find(PRODUCT_ADDONS_POPUP_STEP_PROVIDER_SELECTOR);
            var stateKey = $provider.attr(PRODUCT_ADDONS_POPUP_STATE_KEY_ATTR);

            var onContinue = (popupTemplates[stateKey] || {}).onContinue;
            if (typeof onContinue !== 'function') return;
            var continueToNextPage = onContinue($popup);

            if (!continueToNextPage) return;
            popupContentSetPage($popup, 'next');
        });
    }

    function registerPopupCloseEvent() {
        $(document).on('click', `${PRODUCT_ADDON_POPUP_SELECTOR} ${PRODUCT_ADDON_POPUP_CLOSE_SELECTOR}`, function (el) {
            var $closeButton = $(el.currentTarget);
            var $popup = $closeButton.closest(PRODUCT_ADDON_POPUP_SELECTOR);
            $(document.body).removeClass(CLASS_POPUP_OPEN);
            $popup.removeClass(CLASS_POPUP_OPEN);
        })


        $('[data-product-addon-popup]').on('click', function (el) {
            var $popup = $(el.currentTarget);
            if (typeof $(el.target).attr('data-product-addon-popup') === typeof undefined) return;

            $(document.body).removeClass(CLASS_POPUP_OPEN);
            $popup.removeClass(CLASS_POPUP_OPEN);
        });
    }

    function registerPopupCompleteEvent() {
        $(document).on('click', `${PRODUCT_ADDON_POPUP_SELECTOR} ${PRODUCT_ADDONS_POPUP_COMPLETE_SELECTOR}`, function (el) {
            var $completeButton = $(el.currentTarget);
            var $popup = $completeButton.closest(PRODUCT_ADDON_POPUP_SELECTOR);
            var stateKey = $popup.find(PRODUCT_ADDONS_POPUP_STEP_PROVIDER_SELECTOR)
                .attr(PRODUCT_ADDONS_POPUP_STATE_KEY_ATTR);

            var onComplete = (popupTemplates[stateKey] || {}).onComplete;
            if (typeof onComplete !== 'function') return;
            var complete = onComplete($popup);
            if (!complete) return;

            var state = getPopupContentState($popup);
            addonState[stateKey] = state[stateKey] || {};

            $(document.body).removeClass(CLASS_POPUP_OPEN);
            $popup.removeClass(CLASS_POPUP_OPEN);
        });
    }

    function registerGiftCardSelectEvents() {
        $(document).on('click', `${PRODUCT_ADDON_POPUP_SELECTOR} ${PRODUCT_ADDONS_POPUP_GIFT_CARD_SELECTOR}`, function (el) {
            var $addonProductTile = $(el.currentTarget);
            var $popup = $addonProductTile.closest(PRODUCT_ADDON_POPUP_SELECTOR);
            $popup.find(PRODUCT_ADDONS_POPUP_GIFT_CARD_SELECTOR).removeClass(CLASS_SELECTED);
            $addonProductTile.addClass(CLASS_SELECTED);
        });
    }

    function registerGiftWrapSelectEvents() {
        $(document).on('click', `${PRODUCT_ADDON_POPUP_SELECTOR} ${PRODUCT_ADDONS_POPUP_GIFT_WRAP_SELECTOR}`, function (el) {
            var $addonProductTile = $(el.currentTarget);
            var $popup = $addonProductTile.closest(PRODUCT_ADDON_POPUP_SELECTOR);
            $popup.find(PRODUCT_ADDONS_POPUP_GIFT_WRAP_SELECTOR).removeClass(CLASS_SELECTED);
            $addonProductTile.addClass(CLASS_SELECTED);
        });
    }

    function registerEngravingEvents() {
        var ENGRAVING_SELECTOR = '[data-product-addon-engraving-line-1], [data-product-addon-engraving-line-2], [data-product-addon-engraving-line-3]';

        // DISABLE DYNAMIC PRICING AS PER CLIENT REQUEST
        // $(document).on('change keyup paste', ENGRAVING_SELECTOR, function(el) {
        //   var $input = $(el.currentTarget);
        //   var $popup = $input.closest(PRODUCT_ADDON_POPUP_SELECTOR);
        //   var inputVal = $input.val();

        //   var lineLength = inputVal.length;

        //   if(lineLength > 15) {
        //     $input.val(inputVal.slice(0, 15))
        //   }

        //   var line1 = $popup.find('[data-product-addon-engraving-line-1]').val() || '';
        //   var line2 = $popup.find('[data-product-addon-engraving-line-2]').val() || '';
        //   var line3 = $popup.find('[data-product-addon-engraving-line-3]').val() || '';
        //   var allWords = (line1 + ' ' + line2 + ' ' + line3).trim().split(/\s+/gim).length;

        //   // $('[data-engraving-price-text]').html('$' + (wordPrice * allWords) + ' —');

        //   if(window.templateName !== 'product') {

        //     var wordPrice = $('[data-engraving-price]').attr('data-engraving-price');
        //     wordPrice = !isNaN(parseInt(wordPrice)) ? parseInt(wordPrice) : 0;
        //     wordPrice = wordPrice / 100; // cents
        //   }

        //   // $('[data-engraving-price-text]').html('$' + wordPrice + ' —');

        // })
    }

    function initializeEvents() {
        registerPopupRedrawEvent();
        registerPopupPaginationEvent();
        registerPopupCloseEvent();
        registerPopupCompleteEvent();
        registerGiftCardSelectEvents();
        registerGiftWrapSelectEvents();
        registerEngravingEvents();
        //registerVideoEvents();
    }


    initializeEvents();

    // Init potential product addons and cart addons.
    buildProductAddons();
    buildProductAddons('cart');
    window.buildProductAddons = buildProductAddons;
}


/*window.addEventListener('load', (event) => {
$(function() {
  initializeProductAddons();
});
});*/

function ddefer(method) {
    if (window.jQuery) {
        method();
    } else {
        setTimeout(function () { ddefer(method) }, 50);
    }
}

ddefer(() => { $(function () { initializeProductAddons() }) });